import React, { useState } from 'react'

export const Form = ({ children, errors, schema, initialState }) => {
  const [formInfo, setForm] = useState({ ...initialState })

  return <>{children}</>
}
